import { FC } from 'react';
import ImageIconSolid from '@/components/icons/ImageIconSolid';
import { Skeleton } from '@/components/ui/skeleton';
import { Roles } from '@/@types/auth.types.ts';

type Props = {
	footerButtons?: Roles;
};

const NewsAndOffersCardMobileSkeleton: FC<Props> = ({ footerButtons }) => {
	return (
		<div className='relative -mx-4 p-4 flex gap-4 bg-popover-10 cursor-pointer'>
			<Skeleton className='max-w-1/2 flex-1 flex items-center justify-center rounded-semi-xl overflow-hidden'>
				<ImageIconSolid className='size-8 fill-popover-400' />
			</Skeleton>
			<div className='max-w-1/2 flex-1 flex flex-col gap-2'>
				<div className='flex flex-col gap-2'>
					<Skeleton className='h-3 w-16 my-1.5 rounded-full' />
					<div className='flex flex-col'>
						<Skeleton className='h-3 w-30 my-1 rounded-full' />
						<Skeleton className='h-3 w-39 my-1 rounded-full' />
						<Skeleton className='h-3 w-35 my-1 rounded-full' />
						<Skeleton className='h-3 w-25 my-1 rounded-full' />
					</div>
					<Skeleton className='h-3 w-20 my-1 rounded-full' />
				</div>
				{footerButtons === Roles.admin && (
					<div className='mt-auto flex gap-2'>
						<Skeleton className='h-11 flex-1 rounded-full' />
						<Skeleton className='h-11 flex-1 rounded-full' />
					</div>
				)}
			</div>
		</div>
	);
};

export default NewsAndOffersCardMobileSkeleton;
